import { css } from 'lit';
import sharedStyles from '../../../shared/styles';

export default [
  sharedStyles,
  css`
  td, th {
    padding: 0 1em;
    text-align: left;
  }

  th {
    color: var(--tenable-btn-link-color, #041E47);
  }

  td:first-child, th:first-child {
    padding-left: 0;
  }
  `,
];
